module.exports = __webpack_public_path__ + "img/talentgovhk.77662306.png";